import { useEffect, useState } from "react";
import MainLayout from "../layout/main";
import { accessiblePath, objectToFullText } from "../lib/misc";
import { deleteProduct } from "../service/callAPI";
import Schema from "../type/schema";
import { DataTable } from "../component/DataTable2";
import { ProductStore } from "../service/db";
import { DeleteComponent } from "../component/DeleteComponent";
import { ReloadComponent } from "../component/ReloadComponent";
import moment from "moment";
import Card from "../component/card";
import { toast } from "react-toastify";

export default function ProductListPage() {
	const [refreshTrigger, setRefreshTrigger] = useState(false);
	const [pageProducts, setPageProducts] = useState<Schema.Product[]>([]);
	useEffect(() => {
		loadState();

		async function loadState() {
			const products = await ProductStore.getItems();
			const populatedProducts = products.map((p) => {
				const formattedCreatedAt = p.createdAt
					? moment.unix(+p.createdAt).format("YYYY-MM-DD")
					: "";

				const populated = {
					...p,
					formattedCreatedAt
				};

				const fullText = objectToFullText(populated);
				return {
					...populated,
					fullText
				};
			});

			setPageProducts(populatedProducts);
		}
	}, [refreshTrigger]);
	const [selectedRows, setSelectedRows] = useState<any[]>([]);

	return (
		<MainLayout
			pageTitle="Quản Lý Sản Phẩm"
			title="Quản Lý Sản Phẩm"
			subTitle="Thêm, xóa, sửa sản phẩm. Nhấn vào đây để xem Hướng dẫn sử dụng"
		>
			<Card title="Sản phẩm">
				<DataTable
					selectableRows
					onSelectedRowsChange={(state) => {
						setSelectedRows(state.selectedRows);
					}}
					pagination
					filterEnabled
					customHeaderComponents={[
						DeleteComponent({
							selectedRows,
							setRefreshTrigger,
							deleteById: async (id: string) => {
								await deleteProduct(id);
								await ProductStore.removeItem(id);
							}
						}),
						ReloadComponent({ setRefreshTrigger })
					]}
					columns={[
						{
							name: "Tên sản phẩm",
							selector: (row) => row.name,
							format: (row) => <a href={`/product/${row.id}`}>{row.name}</a>,
							grow: 2,
							sortable: true
						},
						{
							name: "SKU",
							selector: (row) => row.sku,
							sortable: true
						},
						{
							name: "Ngày tạo",
							selector: (row) => row.formattedCreatedAt,
							sortable: true
						},
						{
							name: "Ảnh",
							selector: (row) => row.thumbnailUrl,
							format: (row) => (
								<img
									src={accessiblePath(row.thumbnailUrl)}
									alt={row.name}
									loading="lazy"
									style={{
										height: "120px",
										width: "100px",
										objectFit: "cover"
									}}
								/>
							)
						},
						{
							name: "Giá sản phẩm",
							selector: (row) => row.price,
							sortable: true
						},
						{
							name: "Kho",
							selector: (row) => row.stock,
							sortable: true
						}
					]}
					data={pageProducts}
				/>
			</Card>
		</MainLayout>
	);
}
